import { useTranslation } from "react-i18next";
import {
  Header,
  List,
  ListItem,
  Section,
  SectionTitle,
  Subtitle,
  Text,
  Title,
  Wrapper,
} from "../InfoDocumentComponent/style";
import distributionContent from "./content";
import { Cta, CtaButton, Item, ItemTitle } from "./style";

const renderItems = items =>
  items.map(item => (
    <Item key={item.title}>
      <ItemTitle>{item.title}</ItemTitle>
      <Text>{item.text}</Text>
    </Item>
  ));

export const DistributionComponent = () => {
  const { i18n } = useTranslation();

  const language = String(i18n.language || "").slice(0, 2).toLowerCase();
  const doc = distributionContent[language] || distributionContent.en;

  return (
    <Wrapper>
      <Header>
        <Title>{doc.title}</Title>
        <Subtitle>{doc.subtitle}</Subtitle>
      </Header>

      <Section>
        {doc.intro.map(text => (
          <Text key={text}>{text}</Text>
        ))}
      </Section>

      <Section>
        <SectionTitle>{doc.offersTitle}</SectionTitle>
        <List>
          {doc.offers.map(offer => (
            <ListItem key={offer}>{offer}</ListItem>
          ))}
        </List>
      </Section>

      <Section>
        <SectionTitle>{doc.benefitsTitle}</SectionTitle>
        {renderItems(doc.benefits)}
      </Section>

      <Section>
        <SectionTitle>{doc.stepsTitle}</SectionTitle>
        {renderItems(doc.steps)}
      </Section>

      <Cta>
        <SectionTitle>{doc.ctaTitle}</SectionTitle>
        <Text>{doc.ctaText}</Text>
        <CtaButton to="/contacts">{doc.ctaButton}</CtaButton>
      </Cta>
    </Wrapper>
  );
};
